







































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import publishObjectPath from '@/util/configRegistry';
import { downloadPDF } from '@/views/siteManagement/unit/exportPdfFun';
import { performanceServer, siteManagementServer } from '@/api/installServer';

@Component({
  components: {},
  mixins: [TableStripe],
})
export default class WorkOrderDetailsDialog extends Vue {
  visible: any = false;

  row: any = {
    type: '',
  };
  validatorCodeUrl = ''; // 签名图片路径

  newDataForm: any = {};
  private URLPath: any = '';
  // 表单数据
  private formData: any = {
    applyId: '',
    applyStaffId: '',
    applyStaffName: '',
    approvalFlowExampleId: '',
    controlsRecord: [],
    finishFlag: false,
    finishTime: '',
    id: '',
    processLog: [
      {
        actionList: [],
        afterFlowNode: '',
        afterFlowNodeName: '',
        beforeFlowNode: '',
        beforeFlowNodeName: '',
        endTime: '',
        flowExampleId: '',
        id: '',
        memberList: [
          {
            objId: '',
            objName: '',
            type: '',
          },
        ],
        operation: '',
        operationName: '',
        startTime: '',
        withdraw: false,
      },
    ],
    safetyMeasureRecord: [],
    taskEndTime: '',
    taskStartTime: '',
    taskUnit: '',
    type: '',
    workOrder: '',
  };
  imgPath: any = 'data:image/jpeg;base64,';

  private processLogData: any = [
    {
      beforeFlowNodeName: '申请单位主管意见',
      actionList: [],
    },
    {
      beforeFlowNodeName: '申请单位负责人意见',
      actionList: [],
    },
    {
      beforeFlowNodeName: '生产服务中心调度意见',
      actionList: [],
    },
    {
      beforeFlowNodeName: '主管副总意见',
      actionList: [],
    },
  ];
  private overhaulNature: any = ''; // 检修性质
  private controlsRecordForm: any = {};

  created() {}

  showDialog(row: any) {
    this.row = row;
    this.URLPath = publishObjectPath.imgPathWater;
    this.$nextTick(() => {
      this.getData(this.row);
    });

    this.visible = true;
  }

  mounted() {}

  onExport() {
    const obj: any = {
      type: this.row.type,
      // applyStaffName: this.formData.applyStaffName,
      workOrder: this.formData.workOrder,
    };

    const exportContainer: any = document.getElementById('imageWrapper');
    downloadPDF(exportContainer, obj);

    // const clientWidth = (this.$refs as any).imageWrapper.offsetWidth;
    // const clientHeight = (this.$refs as any).imageWrapper.offsetHeight;
    // const kh = [clientWidth, clientHeight];
    //
    // html2canvas((this.$refs as any).imageWrapper, { useCORS: true, logging: true }).then(canvas => {
    //   const dataURL = canvas.toDataURL('image/png', 1.0);
    //   this.download(dataURL, kh);
    // });
  }

  download(imgUrl: any, kh: any) {
    this.getUrlBase64(imgUrl, kh).then(base64 => {
      const link: any = document.createElement('a');
      link.href = base64;
      link.download = `${this.row.type} - ${this.formData.applyStaffName} -  ${this.formData.workOrder}.jpg`;
      link.click();
    });
  }
  getUrlBase64(url: any, kh: any) {
    return new Promise(resolve => {
      let canvas: any = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const img = new Image();
      img.crossOrigin = '*'; // 允许跨域
      img.src = url;
      img.onload = () => {
        // eslint-disable-next-line prefer-destructuring
        canvas.height = kh[1];
        // eslint-disable-next-line prefer-destructuring
        canvas.width = kh[0];
        ctx.drawImage(img, 0, 0, kh[0], kh[1]);
        const dataURL = canvas.toDataURL('image/png');
        canvas = null;
        resolve(dataURL);
      };
    });
  }

  getData(data: any) {
    // 通过主键查询单条数据
    siteManagementServer
      .getSingleSiteManagementData(data.id)
      .then((res: any) => {
        res.data.controlsRecord.forEach((item: any) => {
          // 检修性质
          if (item.controlsId === 'workTicket-overhaulNature') {
            this.controlsRecordForm.overhaulNature = item.value;
          } else if (item.controlsId === 'workTicket-nameAndOrder') {
            this.controlsRecordForm.nameAndOrder = item.value;
          } else if (item.controlsId === 'workTicket-overhaulContent') {
            this.controlsRecordForm.overhaulContent = item.value;
          } else if (item.controlsId === 'workTicket-powerFailureRange') {
            this.controlsRecordForm.powerFailureRange = item.value;
          } else if (item.controlsId === 'workTicket-applyTimeRange') {
            this.controlsRecordForm.applyTimeRange = item.value;
          } else if (item.controlsId === 'workTicket-approveTimeRange') {
            this.controlsRecordForm.approveTimeRange = item.value;
          } else if (item.controlsId === 'workTicket-staff') {
            this.controlsRecordForm.staff = item.value;
          } else if (item.controlsId === 'workTicket-staffContactWay') {
            this.controlsRecordForm.staffContactWay = item.value;
          }
        });
        // 中部动态内容处理--开始
        res.data.processLog.splice(0, 1);

        res.data.processLog.map((r: any, index1: any) => {
          r.actionList.forEach(async (i: any) => {
            const resInner: any = await this.getSignatureData(i.signature);
            i.deptName = resInner && resInner.deptName ? resInner.deptName : '';
            i.postNames = resInner && resInner.postNames ? resInner.postNames : '';
            i.signature = resInner && resInner.signature ? resInner.signature : '';
          });
        });
        this.formData = res.data;
        res.data.processLog.forEach((item: any) => {
          if (item.actionList && item.actionList.length > 0) {
            item.actionList.forEach((img: any) => {
              this.$set(img, 'imgArr', []);
              if (img.images) {
                this.getSysFile(img);
              }
            });
          }
        });
        this.processLogData.forEach((item: any, index: any) => {
          if (res.data.processLog[index]) {
            this.processLogData[index].actionList = res.data.processLog[index].actionList;
          } else {
            this.processLogData[index].actionList = [];
          }
        });
        console.log(this.processLogData, 'this.processLogData');
      })
      .catch((error: any) => {
        console.log(123);
        this.$message.error('获取数据失败');
      });
  }
  private getSysFile(data: any) {
    performanceServer.getSysFile(data.images).then((res: any) => {
      if (res.code === '200' && res.data.length > 0) {
        data.imgArr = res.data;
      }
    });
  }
  imgPreview(e: any) {
    setTimeout(() => {
      const dom: any = document.getElementsByClassName('el-image-viewer__img');
      for (let i = 0; i < dom.length; i++) {
        dom[i].style.transform = 'scale(1) rotate(270deg)';
      }
    });
  }

  /**
   * @desc 获取签名人信息
   * @param1 暂无
   * @returns 暂无
   */
  async getSignatureData(id: any) {
    if (id) {
      const res: any = await performanceServer.getStaffInfo(id);
      return res.data;
    } else {
      return '';
    }
  }

  /**
   * @desc 获取签名图片
   * @param1 暂无
   * @returns 暂无
   */
  getValidatorCode(id: any): void {
    performanceServer
      .getValidatorCode(id)
      .then((res: any) => {
        // console.log(res);
        // this.validatorCodeUrl = 'data:image/jpeg;base64,' + res.data.signature;
      })
      .catch((error: any) => {
        this.$message.error('获取签名图片失败，请重试！');
      });
  }

  /**
   * @desc 获取签名图片
   * @param1 暂无
   * @returns 暂无
   */
  async getValidatorInnerCode(id: any) {
    const res: any = await performanceServer.getValidatorCode(id);
    return res.data.signature;
  }

  timeBlastingProcess(time: any) {
    const date = new Date(time); //如果date为13位不需要乘1000
    const SY = date.getFullYear();
    const SM = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
    const SD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    return SY + '年' + SM + '月' + SD + '日';
  }

  timeProcess(time: any) {
    const date = new Date(time); //如果date为13位不需要乘1000
    const SY = date.getFullYear();
    const SM = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
    const SD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    const Sh = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
    const Sm = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    return SY + '年' + SM + '月' + SD + '日' + Sh + '时' + Sm + '分';
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击关闭按钮，返回上一级.
   * @param1 暂无
   * @returns 暂无
   */
  close(): void {
    this.newDataForm = {};
    this.validatorCodeUrl = '';
    // this.showWhatFlag = 1;
  }
}
